(() => {
  const decorateUpload = () => {
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    if (!productInfo) return;

    const fileInput = productInfo.querySelector('.customily_option input[type="file"]');
    const option = fileInput && fileInput.closest('.customily_option');
    if (!option || option.classList.contains('vuff-customily-upload')) return;

    const fileWrapper = fileInput.closest('.customily-file-input');
    const button = option.querySelector('.customily-download-button');
    if (!fileWrapper || !button) return;

    option.classList.add('vuff-customily-upload');

    const icon = document.createElement('span');
    icon.className = 'vuff-customily-upload__icon';
    icon.setAttribute('role', 'button');
    icon.setAttribute('tabindex', '0');
    icon.setAttribute('aria-label', 'Choose a pet photo');
    icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M12 16V3m0 0L7 8m5-5 5 5M5 14v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    icon.addEventListener('click', () => fileInput.click());
    icon.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        fileInput.click();
      }
    });

    const optionContent = option.querySelector('.cl-option-content');
    if (!optionContent) return;

    const variantPicker = productInfo.querySelector('variant-selects');
    const personalizeStep = variantPicker?.querySelector('.vuff-variant-option--finish') ? 4 : 3;
    const personalizeHeading = document.createElement('div');
    personalizeHeading.className = 'vuff-customily-personalize-heading';
    personalizeHeading.innerHTML = `<span>${personalizeStep}</span><strong>Personalize</strong>`;
    const customilyForm =
      option.closest('#customily-options') ||
      option.closest('.customily-options-wrapper') ||
      option.closest('#cl_optionsapp') ||
      option.closest('.cl-options-container') ||
      option.parentElement;
    customilyForm.before(personalizeHeading);

    const quantityOffer = productInfo.querySelector('[data-vuff-quantity-offer]');
    const quantity = productInfo.querySelector('[id^="Quantity-Form-"]');
    if (variantPicker) {
      customilyForm.before(variantPicker);
      variantPicker.after(personalizeHeading);
    }
    if (quantityOffer) customilyForm.after(quantityOffer);
    if (quantity && quantityOffer) {
      const quantityAnchor = document.createComment('quantity-position');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      quantity.before(quantityAnchor);
      const placeQuantity = () => {
        if (mobileQuery.matches) quantityOffer.after(quantity);
        else quantityAnchor.after(quantity);
      };
      placeQuantity();
      mobileQuery.addEventListener('change', placeQuantity);
    }

    optionContent.prepend(icon);

    const copy = document.createElement('span');
    copy.className = 'vuff-customily-upload__copy';
    copy.innerHTML = '<strong>Upload a photo</strong><small>Face to camera, natural light, JPG or PNG. One pet per case.</small>';
    icon.after(copy);

    const uploadText = Array.from(button.querySelectorAll('span')).find(
      (span) => span.textContent.trim() === 'Upload Photo'
    );
    if (uploadText) uploadText.textContent = 'Choose file';

  };

  const decorateLoadingText = () => {
    if (document.querySelector('.vuff-loading-overlay__row')) return;

    const overlay = document.querySelector('.loadingoverlay');
    if (!overlay) return;

    const elements = Array.from(overlay.querySelectorAll('*'));
    const text = elements.find(
      (element) =>
        element.children.length === 0 && element.textContent.trim().toLowerCase().includes('ready in under 20 seconds')
    );
    const close = elements.find(
      (element) => element.children.length === 0 && ['×', '✕', 'x'].includes(element.textContent.trim().toLowerCase())
    );
    if (!text || !close) return;

    let row = text.parentElement;
    while (row && row !== overlay && !row.contains(close)) row = row.parentElement;
    if (!row || !row.contains(close)) row = overlay;

    const directChild = (element) => {
      let child = element;
      while (child.parentElement && child.parentElement !== row) child = child.parentElement;
      return child;
    };

    row.classList.add('vuff-loading-overlay__row');
    directChild(text).classList.add('vuff-loading-overlay__message');
    directChild(close).classList.add('vuff-loading-overlay__close');
    text.classList.add('vuff-loading-overlay__text');
  };

  const decorateMobilePreview = () => {
    const source = document.querySelector('.cl-canvas-container[sticky-visible="true"]');
    if (!source || !source.querySelector('#preview-canvas')) return;

    if (window.matchMedia('(max-width: 749px)').matches && !source.dataset.vuffScrollFix) {
      source.dataset.vuffScrollFix = 'true';
      let startX = 0;
      let startY = 0;
      let lastY = 0;

      source.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          startX = touch.clientX;
          startY = touch.clientY;
          lastY = touch.clientY;
        },
        { capture: true, passive: true }
      );

      source.addEventListener(
        'touchmove',
        (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          const movedX = Math.abs(touch.clientX - startX);
          const movedY = Math.abs(touch.clientY - startY);
          if (movedY <= movedX) return;
          event.stopImmediatePropagation();
          window.scrollBy(0, lastY - touch.clientY);
          lastY = touch.clientY;
        },
        { capture: true, passive: true }
      );
    }

    if (document.querySelector('.vuff-mobile-preview')) return;

    const mediaWrapper = source.closest('.product__media-wrapper');
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    if (!mediaWrapper || !productInfo) return;

    const preview = document.createElement('aside');
    preview.className = 'vuff-mobile-preview';
    preview.setAttribute('aria-label', 'Customization preview');
    preview.innerHTML = `
      <div class="vuff-mobile-preview__header">
        <strong>Preview</strong>
        <button type="button" class="vuff-mobile-preview__minimize" aria-label="Minimize preview">&times;</button>
      </div>
      <canvas class="vuff-mobile-preview__canvas" width="320" height="240"></canvas>
      <button type="button" class="vuff-mobile-preview__larger">&#x26F6;&nbsp; View larger</button>
    `;

    const restore = document.createElement('button');
    restore.type = 'button';
    restore.className = 'vuff-mobile-preview__restore';
    restore.textContent = 'Preview';
    restore.setAttribute('aria-label', 'Restore preview');

    const modal = document.createElement('dialog');
    modal.className = 'vuff-mobile-preview__modal';
    modal.innerHTML = `
      <div class="vuff-mobile-preview__modal-header">
        <strong>Preview</strong>
        <button type="button" aria-label="Close larger preview">&#x2304;</button>
      </div>
      <div class="vuff-mobile-preview__stage">
        <canvas width="640" height="640"></canvas>
        <div class="vuff-mobile-preview__zoom" aria-label="Preview zoom controls">
          <button type="button" data-zoom="out" aria-label="Zoom out">&minus;</button>
          <output>100%</output>
          <button type="button" data-zoom="in" aria-label="Zoom in">+</button>
          <button type="button" data-zoom="fit">Fit</button>
        </div>
      </div>
    `;

    document.body.appendChild(preview);
    document.body.appendChild(restore);
    document.body.appendChild(modal);

    const cardCanvas = preview.querySelector('canvas');
    const modalCanvas = modal.querySelector('canvas');
    const zoomOutput = modal.querySelector('output');
    let minimized = false;
    let lastDraw = 0;
    let zoom = 1;

    const setZoom = (value) => {
      zoom = Math.min(2.5, Math.max(1, value));
      modalCanvas.style.transform = `scale(${zoom})`;
      zoomOutput.value = `${Math.round(zoom * 100)}%`;
    };

    const openLargerPreview = () => {
      paint(modalCanvas);
      preview.classList.add('is-modal-open');
      modal.showModal();
    };

    const paint = (target) => {
      const currentSource = document.querySelector('.cl-canvas-container[sticky-visible="true"]');
      const canvases = currentSource && currentSource.querySelectorAll('canvas');
      if (!canvases || !canvases.length) return;

      const context = target.getContext('2d');
      const original = canvases[0];
      if (!context || !original.width || !original.height) return;
      const scale = Math.min(target.width / original.width, target.height / original.height);
      const width = original.width * scale;
      const height = original.height * scale;
      const x = (target.width - width) / 2;
      const y = (target.height - height) / 2;

      context.clearRect(0, 0, target.width, target.height);
      canvases.forEach((canvas) => context.drawImage(canvas, x, y, width, height));
    };

    preview.querySelector('.vuff-mobile-preview__minimize').addEventListener('click', () => {
      minimized = true;
      updateVisibility();
    });

    restore.addEventListener('click', () => {
      minimized = false;
      updateVisibility();
    });

    cardCanvas.setAttribute('role', 'button');
    cardCanvas.setAttribute('tabindex', '0');
    cardCanvas.setAttribute('aria-label', 'View larger preview');
    cardCanvas.addEventListener('click', openLargerPreview);
    cardCanvas.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openLargerPreview();
      }
    });
    preview.querySelector('.vuff-mobile-preview__larger').addEventListener('click', openLargerPreview);

    modal.querySelector('button').addEventListener('click', () => modal.close());
    modal.querySelector('[data-zoom="out"]').addEventListener('click', () => setZoom(zoom - 0.25));
    modal.querySelector('[data-zoom="in"]').addEventListener('click', () => setZoom(zoom + 0.25));
    modal.querySelector('[data-zoom="fit"]').addEventListener('click', () => setZoom(1));
    modal.addEventListener('close', () => {
      setZoom(1);
      preview.classList.remove('is-modal-open');
    });
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });

    const updateVisibility = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const mediaRect = mediaWrapper.getBoundingClientRect();
      const productRect = productInfo.getBoundingClientRect();
      const active = mobile && mediaRect.bottom < 80 && productRect.bottom > 120;
      preview.classList.toggle('is-visible', active && !minimized);
      restore.classList.toggle('is-visible', active && minimized);
    };

    const draw = (time) => {
      if (time - lastDraw > 100 && (preview.classList.contains('is-visible') || modal.open)) {
        paint(cardCanvas);
        if (modal.open) paint(modalCanvas);
        lastDraw = time;
      }
      requestAnimationFrame(draw);
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
    requestAnimationFrame(draw);
  };

  const start = () => {
    decorateUpload();
    decorateLoadingText();
    decorateMobilePreview();
    const observer = new MutationObserver(() => {
      decorateUpload();
      decorateLoadingText();
      decorateMobilePreview();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
